<template>
  <div class="dashboard-widget" :style="position()">
    <div class="dashboard-widget-left" :style="innerPaddingStyle()">
      <div class="dashboard-widget-header">
        <div class="dashboard-widget-header-title-container">
          <div class="dashboard-widget-title">{{ $t(title ?? "") }}</div>
          <div v-if="link">
            <a :href="link">
              <img
                class="dashboard-widget-magnifier"
                :src="'/wp-content/plugins/gespi-dashboard/gespi-dashboard-app/src/assets/images/icons/magnifier.png'"
              />
            </a>
          </div>
          <div v-if="routerLink">
            <RouterLink :to="routerLink"
            >
              <img
                class="dashboard-widget-magnifier"
                :src="'/wp-content/plugins/gespi-dashboard/gespi-dashboard-app/src/assets/images/icons/magnifier.png'"
              />
            </RouterLink>
          </div>
        </div>
        <div>
          <div class="dashboard-widget-total-pis-container"  v-if="count">
            <div class="dashboard-widget-total-pis-title">
              {{ $t("label_dashboard_total_organizations") }}
            </div>


            <div class="dashboard-widget-total-pis-text">
              {{count}}
            </div>


          </div>
          <div class="dashboard-widget-total-pis-container" v-if=" countriesCount">
            <div class="dashboard-widget-total-pis-title">
              {{ $t("label_dashboard_total_countries") }}
            </div>
            <div class="dashboard-widget-total-pis-text">
            {{countriesCount}}
            </div>
          </div>
        </div>
      </div>
      <slot></slot>
    </div>
    <div class="dashboard-widget-right" v-if="$slots.right">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "WidgetContainer",
  props: {
    title: {
      type: String,
    },
    gridColumnStart: {
      type: Number,
    }
    ,
    gridColumnEnd: {
      type: Number
    },
    gridRowStart: {
      type: Number,
    },
    gridRowEnd: {
      type: Number
    },
    widgetPadding: {
      type: String,
    },
    innerPadding: {
      type: String,
    },
    widgetWidth: {
      type: String,
    },
    link: {
      type: String,
    },
    routerLink: {
      type: String,
    },
count:{type:Number,default:0},
    countriesCount:{type:Number,default:0},
  },
  data() {
    return {};
  },
  methods: {
    position: function () {
      return ({
        "grid-column-start": this.gridColumnStart,
        "grid-column-end": this.gridColumnEnd,
        "grid-row-start": this.gridRowStart,
        "grid-row-end": this.gridRowEnd,
        padding: this.widgetPadding ?? "10px 15px",
      })
    },
    innerPaddingStyle: function () {
      return ({
        padding: this.innerPadding ?? "0",
        width: this.widgetWidth,
        flexBasis: this.widgetWidth,
        flexGrow: this.widgetWidth ? 0 : "",
      })
    }

  },
};
</script>

<style lang="scss" scoped>
.dashboard-widget {
  box-shadow: 0 3px 6px #00000029;
  border-radius: 8px;
  background-color: #ffffff;

  display: flex;

  &-left {
    flex: 1;
    display: flex;
    flex-direction: column;
  }

  &-right {
    flex: 2;
    position: relative;
  }

  &-header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    align-items: baseline;
  }

  &-total-pis {
    &-container {
      display: flex;
      align-items: center;
      gap: 5px;
      justify-content: end;
    }

    &-title {
      font-size: 12px;
      font-family: Montserrat, sans-serif;
      color: #4f4e4e;
    }

    &-text {
      font-weight: bold;
      font-size: 14px;
      font-family: Montserrat, sans-serif;
      color: #2f60a6;
    }
  }

  &-title {
    font-weight: 600;
    font-size: 16px;
    font-family: "Poppins-SemiBold", sans-serif;

    letter-spacing: 0;
    color: #273A76;
  }
}

.dashboard-widget-header-title-container {
  display: flex;
  align-items: center;
  gap: 5px;
}

.dashboard-widget-magnifier {
  width: 13px;
  height: 13px;
  cursor: pointer;
  object-fit: contain;
}
</style>
